import React, {Component} from 'react';
import {
	Select,
	SelectItem,
	Toggle
} from '@carbon/react';
import PropertyComponent from './PropertyComponent';

import * as midi from '../js/rpl_midi.js';

class FirmwareVersionField extends PropertyComponent {
	constructor(props) {
		super(props);

		this.state = {
			textValue : 'unknown'
		};
	}

	render() {
		return (
			<span>Firmware: {this.state.textValue}</span>
		);
	}

	setText(x) {
		this.setState({textValue: x})
	}
}

class ErrorCodeField extends PropertyComponent {
	constructor(props) {
		super(props);

		this.state = {
			textValue : undefined
		};
	}

	render() {
		if (this.state.textValue != undefined) {
			return (
				<span>Error: {this.state.textValue}</span>
			);
		} else {
			return (
				<span></span>
			);
		}
	}

	setText(x) {
		this.setState({textValue: x})
	}
}

/*
 * Polls PSU voltage and calculates basic statistics.
 */
class PSUVoltageField extends React.Component {
    constructor(props) {
        super(props);

		this.handleToggle = this.handleToggle.bind(this);

        this.labelText = props.labelText;
        this.propId    = props.propId;

        this.state = {
			showVoltage: 0,
            value: 0
        };
    }

	/*
	componentDidMount() {
		if (this.propId != undefined) {
			midi.addPropertySubscriber(this.propId, this);
		}

		this.timerID = setInterval(
						() => this.tick(),
						1000
					);
	}

	componentWillUnmount() {
		if (this.propId != undefined) {
			midi.removePropertySubscriber(this.propId, this);
		}

		clearInterval(this.timerID);
	}
	*/

	render() {
		return (
			<div>
			<Toggle id="psu-voltage-toggle" labelText="PSU Voltage"
					labelA=""
					labelB={this.state.value > 0 ? this.state.value + "V" : "not available"}
					toggled={this.state.showVoltage != 0}
					disabled={this.state.disabled}
					onToggle={this.handleToggle} />
			</div>
		);
	}

	handleToggle(on) {
		this.setState({showVoltage: on ? 1 : 0});

		if (on) {
			if (this.propId != undefined) {
				midi.addPropertySubscriber(this.propId, this);
			}

			this.timerID = setInterval(
							() => this.tick(),
							1000
						);
		} else {
			if (this.propId != undefined) {
				midi.removePropertySubscriber(this.propId, this);
			}

			clearInterval(this.timerID);
		}
	}

	setValue(x) {
		this.setState({value: x})
	}

	tick() {
		midi.getPropertyValue(this.propId);
	}
}

class MidiChannelSelector extends PropertyComponent {
	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);

		this.state = {
			value : 0
		};
	}

	render() {
		return (
	  		  <Select labelText="MIDI Channel" value={this.state.value} onChange={this.handleChange}>
	  		    <SelectItem text="Channel 1" value="0"/>
	  		    <SelectItem text="Channel 2" value="1"/>
	  		    <SelectItem text="Channel 3" value="2"/>
	  		    <SelectItem text="Channel 4" value="3"/>
	  		    <SelectItem text="Channel 5" value="4"/>
	  		    <SelectItem text="Channel 6" value="5"/>
	  		    <SelectItem text="Channel 7" value="6"/>
	  		    <SelectItem text="Channel 8" value="7"/>
	  		    <SelectItem text="Channel 9" value="8"/>
	  		    <SelectItem text="Channel 10" value="9"/>
	  		    <SelectItem text="Channel 11" value="10"/>
	  		    <SelectItem text="Channel 12" value="11"/>
	  		    <SelectItem text="Channel 13" value="12"/>
	  		    <SelectItem text="Channel 14" value="13"/>
	  		    <SelectItem text="Channel 15" value="14"/>
	  		    <SelectItem text="Channel 16" value="15"/>
	  		  </Select>
		);
	}

	handleChange(event) {
		var newValue = event.target.value;
		this.setState({value: newValue});
		midi.setMIDIChannel(newValue);
	}

	setValue(x) {
		this.setState({value: x});
	}
}

export { FirmwareVersionField, ErrorCodeField, PSUVoltageField, MidiChannelSelector };
